import { Check, X } from "@aircall/react-icons";

import { BinaryAnswerValue } from "@/graphql/generated/graphql";
import { ExcludeNotApplicable } from "../EvaluationResult/EvaluationResult.decl";

export function pickIcon(value: ExcludeNotApplicable<BinaryAnswerValue>) {
  switch (value) {
    case "YES":
      return Check;
    case "NO":
      return X;
    default:
      return null;
  }
}
